import { createSlice } from "@reduxjs/toolkit";

const contactSlice = createSlice({
  name: "contact",
  initialState: {
    sourceSlug: null,
    sourceTitle: null,
  },
  reducers: {
    setContactSource: (state, action) => {
      state.sourceSlug = action.payload.slug;
      state.sourceTitle = action.payload.title;
    },
    clearContactSource: (state) => {
      state.sourceSlug = null;
      state.sourceTitle = null;
    },
  },
});

export const { setContactSource, clearContactSource } = contactSlice.actions;
export default contactSlice.reducer;
